import {connect} from 'react-redux';
import {compose, withProps} from 'react-recompose';
import {CommonActions} from '@react-navigation/native';
import config from '../../config';
import I18n from '../../lib/i18n';
import ChangePlan from './ChangePlan';
import {
  setSubscriptionToUpdate,
  updateSelectedSubscription,
} from '../../modules/Subscriptions';
import {initStateWithOffer} from '../../modules/NewOffer';
import {isExemptedFromTaxSelector} from '../../modules/Customer/selectors';
import {
  isNewOfferValidSelector,
  newOfferPeriodicitySelector,
  newOfferPriceSelector,
  newOfferSelector,
} from '../../modules/NewOffer/selectors';
import {
  availableServiceOptionsSelector,
  getCreditableOptionsWithPlan,
  getLocalCreditableOptionsWithPlan,
  hasRoamingCreditableOptions,
} from '../../modules/AvailableOption/selectors';
import Navigation from '../../lib/navigation';
import {isLoadingSelector} from '../../modules/LoadingStatus';
import {firstAvailableCreditableOptionsForActivationOrderSelector} from '../../modules/AvailableOption/selectors';

const mapStateToProps = state => ({
  creditableOptions: config.displayRoamingPlanSliders
    ? getLocalCreditableOptionsWithPlan(state)
    : getCreditableOptionsWithPlan(state),
  creditableOptionForActivation:
    firstAvailableCreditableOptionsForActivationOrderSelector(state),
  serviceOptions: availableServiceOptionsSelector(state),
  price: newOfferPriceSelector(state),
  periodicity: newOfferPeriodicitySelector(state),
  disableNextButton: !isNewOfferValidSelector(state),
  isExemptedFromTax: isExemptedFromTaxSelector(state),
  subscriptionToUpdate: state.subscriptions.subscriptionToUpdate,
  newOffer: newOfferSelector(state),
  isConfirmationLoading: isLoadingSelector(state, 'changePlanConfirmation'),
  hasRoamingOptions: hasRoamingCreditableOptions(state),
});

const mapDispatchToProps = dispatch => ({
  updateSelectedSubscription: newOffer => {
    dispatch(updateSelectedSubscription(newOffer));
    Navigation.dispatch(
      CommonActions.navigate({name: 'confirmPlanDuringActivate'}),
    );
  },
  setSubscriptionToUpdate: () => dispatch(setSubscriptionToUpdate()),
  initStateWithOffer: offer => dispatch(initStateWithOffer(offer)),
});

const withEditPlanDuringActivateProps = {
  buttonText: I18n.t(
    'EditPlanWithUnavailableOfferDuringActivate.confirmButton',
  ),
  confirmModalText: I18n.t(
    'EditPlanWithUnavailableOfferDuringActivate.confirmModal',
  ),
  orderType: 'ACTIVATION',
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(withEditPlanDuringActivateProps),
)(ChangePlan);
